<template>
  <div class="card">
    <div class="card-header" id="'headingTwo'">
      <h5 class="mb-0">
        <button
          class="btn btn-link collapsed"
          data-toggle="collapse"
          :data-target="'#collapseTwo'"
          aria-expanded="false"
          :aria-controls="'collapseTwo'"
        ></button>
      </h5>
    </div>

    <div class="card-body">
      <div>
        <form v-on:submit.prevent="onSubmit">
          <div class="form-group">
            <label for="executorLabel">Izvrsilac :</label>
            <select class="form-control" id="executorLabel" v-model="person">
              <option v-for="admin in getAdmins" :key="admin.index">{{
                admin
              }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="locationLabel">Lokacija :</label>
            <select class="form-control" id="locationLabel" v-model="location">
              <option
                v-for="location in getOptions.location"
                :key="location.index"
                >{{ location }}</option
              >
            </select>
          </div>
          <div class="form-group">
            <label for="workTime"> Vrsta termina :</label>
            <select class="form-control" id="workTime" v-model="workTime">
              <option v-for="work in getOptions.workTime" :key="work.index">{{
                work
              }}</option>
            </select>
          </div>

          <div class="form-group mt-2">
            <label for="selectedDate">Izaberi datum i vrijeme :</label>
            <date-time-picker v-model="selectedDate"></date-time-picker>
            <span v-text="selectedDate"></span>
          </div>
          <div class="form-group mt-2">
            <label for="workTimeUnit">Jedinica mjere :</label>
            <select class="form-control" id="workTimeUnit" disabled="disabled">
              <option selected="true">Sat</option>
            </select>
          </div>
          <div class="form-group">
            <label for="amountOfWork">Kolicina</label>
            <input
              type="number"
              class="form-control"
              id="amountOfWork"
              min="1"
              value="1"
              v-model="workTimeSpent"
            />
          </div>
          <div class="form-group">
            <label for="cityLabel">Grad :</label>
            <select class="form-control" id="cityLabel" v-model="city">
              <option v-for="city in getOptions.city" :key="city.index">{{
                city
              }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="description">Opis</label>
            <textarea
              class="form-control"
              id="description"
              rows="3"
              v-model="description"
            ></textarea>
          </div>
          <button type="submit" class="btn btn-primary" v-if="added">
            Dodaj zadatak
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import DateTimePicker from "@/components/Common/DateTimePicker";
import UsedMaterials from "@/components/Worklog/UsedMaterials";
import EventBus from "@/eventBus";
/*eslint-disable*/
export default {
  components: {
    "used-materials": UsedMaterials,
    "date-time-picker": DateTimePicker
  },
  props: {
    data: Object
  },
  mounted() {
    EventBus.$on("EDIT_TASK", response => {
      if (response) {
        this.person = response.person;
        this.location = response.location;
        this.workTime = response.workTime;
        this.workTimeUnit = response.workTimeUnit;
        this.workTimeSpent = response.workTimeSpent;
        this.city = response.city;
        this.description = response.description;
        this.editMode = true;
        this.id = response.id;
      }
    });
  },
  data() {
    return {
      editMode: false,
      person: "",
      location: "",
      workTime: "",
      isWorkHours: false,
      workTimeUnit: "hour",
      workTimeSpent: 0,
      city: "",
      description: "",
      usedMaterial: false,
      usedMaterials: 1,
      matId: 0,
      added: true,
      id: 0,
      selectedDate: new Date()
    };
  },
  computed: {
    getAdmins() {
      return this.$store.getters.getAdmins;
    },
    getOptions() {
      return this.$store.getters.getOptions;
    },
    getExecuteData() {
      return this.$store.getters.getExecuteData;
    },
    getMaterials() {
      return this.$store.getters.getMaterials;
    }
  },
  methods: {
    onSubmit(event) {
      var number = Math.random();
      number.toString(36);
      var id = this.editMode ? this.id : number.toString(36).substr(2, 9);

      const newTask = {
        id: id,
        person: this.person,
        date: this.selectedDate,
        location: this.location,
        workTime: this.workTime,
        workTimeUnit: this.workTimeUnit,
        workTimeSpent: this.workTimeSpent,
        city: this.city,
        description: this.description
      };
      event.target.reset();
      this.editMode = false;
      this.$emit("newTask", newTask);
    }
  }
};
</script>
